import { TemplateElement, html, defineElement } from '@webtides/element-js';
import '../icon/icon.js';
import style from './page-legend-progress.css';

/**
 * @property {array} legendItems
 */
export default class PageLegendProgress extends TemplateElement {
    sections = [];
    intersections = [];

    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            legendItems: [],
            progress: 0,
        };
    }

    connected() {
        this.legendItems.map((item) => {
            this.sections.push(document.getElementById(item.slug));
        });

        const intersectionObserver = new IntersectionObserver((entries) => {
            entries.map((entry) => {
                const intersection = this.intersections.find((item) => item.id === entry.target.id);

                if (intersection) {
                    intersection.isIntersecting = entry.isIntersecting;
                }
            });
        });

        this.sections.map((section) => {
            this.intersections.push({ section: section, id: section.id, isIntersecting: false });
            intersectionObserver.observe(section);
        });
    }

    events() {
        return {
            window: {
                scroll: () => {
                    this.updateProgress();
                },
                hashchange: () => {
                    this.updateProgress();
                },
            },
        };
    }

    updateProgress() {
        const intersection = this.intersections.find((item) => item.isIntersecting === true);

        if (intersection) {
            const activeProgressItem = document.getElementById(`progress-item-${intersection.id}`);
            const activeSection = intersection.section;

            const { offsetLeft: offsetLeftActiveProgressItem, clientWidth: clientWidthActiveProgressItem } =
                activeProgressItem;
            const { offsetTop: offsetTopActiveSection, clientHeight: clientHeightActiveSection } = activeSection;
            const { clientWidth: containerWidth } = this.$refs.container;

            this.progress = (offsetLeftActiveProgressItem / containerWidth) * 100;

            const sectionProgressWidthRatio = clientWidthActiveProgressItem / containerWidth;
            const activeSectionScrollHeightRatio =
                (window.scrollY - offsetTopActiveSection) / clientHeightActiveSection;

            this.progress += sectionProgressWidthRatio * activeSectionScrollHeightRatio * 100;

            this.progress = Math.max(this.progress, 0);

            const scrollValue = (this.progress / 100) * containerWidth - containerWidth / 3;
            this.scrollTo({
                top: 0,
                left: scrollValue,
                behavior: 'smooth',
            });
        }
    }

    template() {
        return html`
            <div class="flex-col pb-8 inline-flex bg-white" ref="container">
                <progress max="100" aria-label="progress-bar" value="${this.progress}"></progress>
                <div class="flex flex-row gap-16 text-nowrap">
                    ${this.legendItems.map(
                        (item) => html`
                            <a href="#${item.slug}" id="progress-item-${item.slug}" class="block text-gray-70 ">
                                ${item.title}
                            </a>
                        `,
                    )}
                </div>
            </div>
        `;
    }
}

defineElement('mb-page-legend-progress', PageLegendProgress);
